export const RETURN_PARAM = 'return';

const DENYLISTED_PATHS = new Set(['/login', '/register']);

const LABEL_MAP = {
  '/': 'Home',
  '/profile/me': 'My Profile',
  '/settings': 'Settings',
  '/settings/widgets': 'My Widgets',
  '/friends': 'Friends',
  '/events': 'Events',
  '/groups': 'Groups',
  '/memories': 'Memories'
};

export function getFullCurrentPath() {
  if (typeof window === 'undefined') {
    return '';
  }

  const { pathname, search, hash } = window.location;
  return `${pathname}${search}${hash}`;
}

export function isSafeReturnPath(path) {
  if (!path || typeof path !== 'string') {
    return false;
  }
  if (!path.startsWith('/')) {
    return false;
  }
  if (path.startsWith('//')) {
    return false;
  }
  if (path.includes('://')) {
    return false;
  }

  const pathname = path.split('?')[0].split('#')[0];
  return !DENYLISTED_PATHS.has(pathname);
}

export function getCurrentReturnPath() {
  if (typeof window === 'undefined') {
    return null;
  }

  const { pathname, search, hash } = window.location;
  if (pathname === '/docs' || pathname.startsWith('/docs/')) {
    return null;
  }

  return `${pathname}${search}${hash}`;
}

export function readReturnPath(fallback) {
  if (typeof window === 'undefined') {
    return fallback && isSafeReturnPath(fallback) ? fallback : null;
  }

  const params = new URLSearchParams(window.location.search);
  const value = params.get(RETURN_PARAM);
  if (value && isSafeReturnPath(value)) {
    return value;
  }

  if (fallback && isSafeReturnPath(fallback)) {
    return fallback;
  }

  return null;
}

export function getEffectiveReturnPath() {
  return readReturnPath() || getCurrentReturnPath();
}

export function appendReturnTo(href, returnTo) {
  const returnPath = returnTo ?? getEffectiveReturnPath();
  if (!returnPath || !isSafeReturnPath(returnPath)) {
    return href;
  }

  const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
  const url = new URL(href, base);
  url.searchParams.set(RETURN_PARAM, returnPath);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function returnPathLabel(path) {
  if (!path) {
    return 'Previous page';
  }

  const pathname = path.split('?')[0].split('#')[0];
  if (LABEL_MAP[pathname]) {
    return LABEL_MAP[pathname];
  }

  if (pathname.startsWith('/groups/')) {
    return 'Group';
  }
  if (pathname.startsWith('/settings/')) {
    return 'Settings';
  }

  return 'Previous page';
}
